import React, {useEffect, useMemo, useState} from 'react';
import {Tab} from 'semantic-ui-react';
import {useBlockUI} from "../../../../shared/services/block-ui-service";
import SessionStorage from "../../../../store/session";
import {SessionUser} from "../../../../models/session-user";
import {useLocation, useParams} from "react-router-dom";
import FleetDriversListComponent from "../../../../components/fleet-drivers-list/fleet-drivers-list";


const FleetDriversList = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [fleetId, setFleetId] = useState<string | null>(); // Estado para armazenar o clientId
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const [activeIndex, setActiveIndex] = useState<number>();
    const location = useLocation();
    const {id} = useParams();

    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])

    useEffect(() => {
        setFleetId(id);
    }, [id]);


    const panes = useMemo(() => [
        {
            menuItem: 'Listagem de Motoristas da Operação',
            render: () => <Tab.Pane>
                {fleetId && <FleetDriversListComponent fleetId={fleetId}/>}
            </Tab.Pane>
        },
    ], [fleetId]);

    return (
        <Tab
            menu={{fluid: true, vertical: false, tabular: true}}
            panes={panes}
            activeIndex={activeIndex}
            onTabChange={(e, {activeIndex}) => {
                setActiveIndex(typeof activeIndex === 'string' ? parseInt(activeIndex, 10) : activeIndex);
            }}
        />
    );
};

export default FleetDriversList;
